import { Component, OnInit, Optional } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Listing, SetupService, BookingService, EventService, TrackingService, Booking } from '@clooper/core';
import { faTimes, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modify-contact-booking',
  templateUrl: './modify-contact-booking.component.html',
  styleUrls: ['./modify-contact-booking.component.scss']
})
export class ModifyContactBookingComponent implements OnInit {
  icons = {
    cancel: faTimes,
    chevronRight: faChevronRight
  }
  public onClose: Subject<boolean>;

  listing: Listing;
  form = new FormGroup({
    first_name: new FormControl('', []),
    last_name: new FormControl('', []),
    email: new FormControl('', [Validators.email, Validators.required]),
    phone: new FormControl('', [Validators.pattern('[- +()0-9]{7,}'), Validators.required]),
    address: new FormControl('', []),
    message: new FormControl('', [Validators.required]),
  });
  loading = false;
  checkIn: any;
  person: any;
  bookingId: any;
  showNext: boolean;
  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private options: ModalOptions,
    private setupService: SetupService,
    private bookingService: BookingService,
    private route: ActivatedRoute,
    @Optional() private eventService: EventService,
    private tracker: TrackingService,

  ) {
    this.bookingId = this.options?.initialState?.booking

    if (this.options.initialState?.edit) {
      let { booking } = this.options.initialState
      this.person = this.options.initialState?.person;
      let { first_name, last_name, email, phone, location } = this.person;
      this.bookingId = booking;
      this.person = this.options.initialState.person_original
      this.form = this.fb.group({
        name: new FormControl(`${first_name + ' ' + last_name}`, []),
        email: new FormControl(email, [Validators.email, Validators.required]),
        phone: new FormControl(phone, [Validators.required, Validators.pattern('[- +()0-9]{7,}')]),
        location: new FormControl(location, []),
        message: new FormControl('', [Validators.required]),

      })

      !phone ? this.form.controls.phone.markAsTouched() : null
    }

  }
  ngOnInit(): void {

    this.onClose = new Subject();
    // console.log(this.route.snapshot.params.id)

  }

  onConfirm(): void {
    let formData;
    const { name, email, phone, location, message } = this.form.value;
    formData = { contact_person: { email, phone, location, name, },  message}
    const payload = { ...formData };
    // console.log(payload)
    this.loading = true;
    this.bookingService.modifyUserBooking(this.bookingId, payload).subscribe(res => {
     if (res) {
      this.showNext = true
     } // window.location.reload()
    }).add(() => this.loading = false)
  }

}
